import { render, staticRenderFns } from "./ListaLegado.vue?vue&type=template&id=def36a6c"
import script from "./ListaLegado.vue?vue&type=script&lang=js"
export * from "./ListaLegado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports